module.exports = __webpack_public_path__ + "static/cd-cover-81a79b390634c3b3b3c99a3928de1a73.png";